import { createAxiosInstance } from 'api/request';
import type { FormErrors, RecursivePartial } from 'types';
import type { User } from 'types/user';
import type { ProductKey } from 'utils/products';

export async function validateUserData(user: Partial<User>): Promise<{ success: boolean; errors?: FormErrors }>
{
  return createAxiosInstance()
    .post('/user/validate', { ...user })
    .then(() => ({ success: true }))
    .catch((err) => ({ success: false, errors: err.response?.data?.errors }));
}

export async function updateUserProfile(user: RecursivePartial<User>): Promise<{ success: boolean; errors?: FormErrors }>
{
  return createAxiosInstance()
    .patch('/user/profile', { ...user })
    .then(() => ({ success: true }))
    .catch((err) => ({ success: false, errors: err.response?.data?.errors }));
}

export async function registerUser(user: Partial<User>): Promise<{ success: boolean; url?: string; errors?: FormErrors }>
{
  return createAxiosInstance()
    .post('user/v1/register', { ...user })
    .then((res) => ({ success: true, url: (res.data as any).url }))
    .catch((err) => ({ success: false, errors: err.response?.data?.errors }));
}

export async function upgradeUser(user: Partial<User>, productKey: ProductKey, couponCode?: string): Promise<{ success: boolean; url?: string; errors?: FormErrors }>
{
  return createAxiosInstance()
    .post('user/upgrade', { ...user, abo: productKey, couponCode })
    .then((res) => ({ success: true, url: (res.data as any).url }))
    .catch((err) => ({ success: false, errors: err.response?.data?.errors }));
}

export async function onboardUser(user: Partial<User>, productKey: ProductKey, couponCode?: string): Promise<{ success: boolean; url?: string; errors?: FormErrors }>
{
  return createAxiosInstance()
    .post('user/v1/onboarding', { ...user, abo: productKey, couponCode })
    .then((res) => ({ success: true, url: (res.data as any).url }))
    .catch((err) => ({ success: false, errors: err.response?.data?.errors }));
}